import { FC } from "react";
import { useTranslation } from "react-i18next";
import { RoleRightMode, RoleRightType } from "../../models/role";
import {
  AdminRoleRadio,
  AdminRoleRadioContainer,
  AdminRoleRightContainer,
} from "./AdminRoleStyles";

interface IProps {
  name: string;
  label?: string;
  mode?: RoleRightMode;
  firstColumn?: string;
  noneValue?: string | number;
  readValue?: string | number;
  writeValue?: string | number;
}

const AdminRoleRight: FC<IProps> = ({
  name,
  label,
  mode = RoleRightMode.Both,
  firstColumn,
  noneValue = RoleRightType.None,
  readValue = RoleRightType.Read,
  writeValue = RoleRightType.Write,
}) => {
  const { t } = useTranslation();

  return (
    <AdminRoleRightContainer firstColumn={firstColumn}>
      <div>{label ?? t("admin.role." + name)}</div>
      <AdminRoleRadioContainer>
        <AdminRoleRadio name={name} type="radio" value={noneValue} />
      </AdminRoleRadioContainer>
      <AdminRoleRadioContainer
        className={mode !== RoleRightMode.Write ? undefined : "hidden"}
      >
        <AdminRoleRadio name={name} type="radio" value={readValue} />
      </AdminRoleRadioContainer>
      <AdminRoleRadioContainer
        className={mode !== RoleRightMode.Read ? undefined : "hidden"}
      >
        <AdminRoleRadio name={name} type="radio" value={writeValue} />
      </AdminRoleRadioContainer>
    </AdminRoleRightContainer>
  );
};

export default AdminRoleRight;
